import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  loader: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: '24px',
    height: '600px',
    width: '1000px'
  }
}));
